<script>
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import EventHeaderIconBoxMobile from './EventHeaderIconBoxMobile.vue';
import EventHeaderTabs from './EventHeaderTabs.vue';
export default {
  name: 'FormGuideEventHeaderMobile',
  components: {
    RelativeTime,
    EventHeaderIconBoxMobile,
    EventHeaderTabs,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    eventName: {
      type: String,
      required: true,
    },
    localStart: {
      type: String,
      required: true,
    },
    isResulted: {
      type: Boolean,
      required: true,
    },
    isImminent: {
      type: Boolean,
      required: true,
    },
    isEnded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<template>
  <div class="form-guide-event-header-mobile">
    <div class="form-guide-event-header-mobile__container">
      <div class="form-guide-event-header-mobile__time">
        <RelativeTime
          v-if="isImminent || isEnded"
          :brand="`punters`"
          :target-time="startTime"
          :is-resulted="isResulted"
        />
        <div
          v-if="startTime"
          class="form-guide-event-header-mobile__start-time"
        >{{ startTime | sportsCalendarPunters }} {{ localStart | puntersDisplayTime }}</div>
      </div>
      <div class="form-guide-event-header-mobile__name">{{ eventName }}</div>
      <div class="form-guide-event-header-mobile__icons">
        <EventHeaderIconBoxMobile :icon-type="`eventCondition`" />
        <EventHeaderIconBoxMobile :icon-type="`prizeMoney`" />
        <EventHeaderIconBoxMobile :icon-type="`trackDistance`" />
        <EventHeaderIconBoxMobile :icon-type="`trackCondition`" />
        <EventHeaderIconBoxMobile :icon-type="`moreModal`" />
      </div>
    </div>
    <EventHeaderTabs :is-mobile="true" />
  </div>
</template>
